import styled from 'styled-components'

const HeadingWrapper = styled.div`
 margin-top: 50px;
`
const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: #000;
  justify-content: center;
  padding: 20px;
  > div {
    max-width: 730px;
    margin: 0 auto;
  }
  img {
    margin-bottom: 28px;
  }
  h3 {
    font-size: 24px;
    font-family: 'latoregular';
    margin-bottom: 16px;
  }
  h2 {
    font-size: clamp(40px, 5.5vw, 60px);
    font-family: 'latobold';
    margin-bottom: 9px;
  }
  p {
    font-size: 20px;
    font-family: 'latomedium';
    text-align: center;
  }
`;
const PalletsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
  max-width: 951px;
  padding : 0 15px;
  margin: 0 auto;
  margin-top: 25px;
  margin-bottom: 20px;
  @media(max-width: 770px) {
    grid-template-columns: 1fr;
  }
`
const LoadMarketPlace = styled.div`
    color: #fff;
    border-radius: 3.3px;
    box-shadow: 0 0 22px 0 rgba(0, 0, 0, 0.11);
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 17px;
    cursor: pointer;
    margin-bottom:4px;
    > svg {
        font-size: 30px;
    }
`
const SellPallets = styled.div`
 max-width: 448px;
  width: 100%;
  padding: 20px 20px;
  border-radius: 6.6px;
  background-color: #0a1f30;
  color: #fff;
    display: grid;

  margin: 0 auto;
  ${LoadMarketPlace} {
    background-color: #01b3ff;

  }
  .seacrh-icon {
    background-color: #01b3ff;
    cursor: pointer;
  }
  > h3 {
      font-size: 22px;
      margin-bottom: 19px;
      font-family: 'latobold';
  }
  > h4 {
      font-size: 13px;
      font-family: 'latomedium';
      margin-bottom: 10px;
      
  }
  p {
      font-size: 13px;
      font-family: 'latomedium';
      margin-bottom:32px;
      margin-top: 15px;
  }

`

const BuyPallets = styled.div`
  max-width: 448px;
  display: grid;
  width: 100%;
  padding: 20px 30px;
  border-radius: 6.6px;
  background-color: #01b3ff;
  color: #fff;
  margin: 0 auto;
  ${LoadMarketPlace} {
    background-color: #0a1f30;

  }
  .seacrh-icon {
    background-color: #0a1f30;
    cursor: pointer;
  }
  > h3 {
      font-size: 22px;
      margin-bottom: 19px;
      font-family: 'latobold';
  }
 
  p {
      font-size: 13px;
      font-family: 'latomedium';
      margin-bottom:32px;
      margin-top: 15px;
  }
`
const SearchWrapper = styled.div``
const SearchWrapperHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 6px;
     > h4 {
      font-size: 13px;
      font-family: 'latomedium';
      text-transform: uppercase;
            margin-bottom: 0;
  }
  > p{
    margin: 0;
    border: 1px solid #fff;
    padding: 1px 10px;
    cursor: pointer;
  }
`

export { Heading, HeadingWrapper, PalletsWrapper, BuyPallets, SearchWrapper, LoadMarketPlace, SellPallets, SearchWrapperHeader };